export default __webpack_public_path__ + "static/media/Maxvit-D-40000-ban.895849ff.jpg";